
import { useEffect } from 'react'
import Select from 'react-select'
import { useDispatch, useSelector } from 'react-redux'
import { useAuthState } from '../../Helper/Context'
import { Get_DDL_M_Project_Grid_SelectDDLAPI, Get_DDL_M_Ward_Grid_SelectDDLAPI, ProjectNameIUDDLAPI } from '../../Redux/DDLSlice'

export const ProjectNameIUDDL = (props) => {
    const { ProjectType, ProjectNameIU, setProjectNameIU, WardID, rowData, Flag, APIFlag, IsPost } = props
    
    // console.log(rowData)

    const userDetails = useAuthState();
    const { UserID, token } = userDetails.user
    const dispatch = useDispatch()

    useEffect(() => {
        const data = { ProjectType, WardID, Flag: APIFlag, UserID, token }
        dispatch(ProjectNameIUDDLAPI({ data }))
    }, [IsPost, ProjectType, APIFlag])

    const { ProjectNameIUDDLDataa } = useSelector(state => state.ProjectNameIUDDLData)

    useEffect(() => {
        handleProjectNameIUDDL()
    }, [ProjectNameIUDDLDataa])

    const handleProjectNameIUDDL = () => {
        // console.log(DeptDDLDataa)
        if (ProjectNameIUDDLDataa && ProjectNameIUDDLDataa.table && ProjectNameIUDDLDataa.table.length > 0) {
            let list = ProjectNameIUDDLDataa.table.map((item, index) => ({
                value: (item.m_ProjectID || item.projectID),
                label: item.projectName,
            }))

            setProjectNameIU({
                DDL: list,
                ID: Flag === 'Update' ? (rowData.m_ProjectID || rowData.projectID) : 0,
                Label: Flag === 'Update' ? rowData.projectName : "Select...",
            })
        }
        else {
            setProjectNameIU({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }

    }

    return (
        <div className="form-group">
            <label className="d-block" htmlFor="NameofDepartment"><b>Project Name </b></label>
            <Select
                isClearable
                // isRtl={isRtl}
                // className="ddl_width"
                // className="ddl_width"
                isSearchable
                maxMenuHeight={150}
                value={{ value: ProjectNameIU.ID, label: ProjectNameIU.Label }}
                onChange={(e) => {
                    e ?
                        setProjectNameIU({ ...ProjectNameIU, ID: e.value, Label: e.label })
                        :
                        setProjectNameIU({ ...ProjectNameIU, ID: 0, Label: "Select..." })

                }}
                options={ProjectNameIU.DDL}
            />
        </div>
    )
}